"use strict";

export function videoInit(container, classname) {
  const videoContainers = (container ?? document).getElementsByClassName(
    classname ?? "load-video"
  );

  for (let i = 0; i < videoContainers.length; i++) {
    if (!videoContainers[i].hasAttribute("data-videosrc")) {
      continue;
    }
    let videosrc = videoContainers[i].getAttribute("data-videosrc");
    if (!videosrc) {
      continue;
    }

    if (
      document.body.classList.contains("mobile") &&
      videoContainers[i].classList.contains("no-mobile")
    )
      continue;

    let videoAutoplay = true;
    let videoloop = true;
    let videocontrols = false;
    let videomuted = true;

    let videoAutoplaySeting =
      videoContainers[i].getAttribute("data-videoautoplay");
    if (videoAutoplaySeting) {
      videoAutoplay = videoAutoplaySeting == "false" ? false : true;
    }

    let videoloopSeting = videoContainers[i].getAttribute("data-videoloop");
    if (videoAutoplaySeting) {
      videoloop = videoloopSeting == "false" ? false : true;
    }

    let videoControlsSeting =
      videoContainers[i].getAttribute("data-videocontrols");
    if (videoControlsSeting) {
      videocontrols = videoControlsSeting == "false" ? false : true;
    }

    let videoMutedSeting = videoContainers[i].getAttribute("data-videomuted");
    if (videoMutedSeting) {
      videomuted = videoMutedSeting == "false" ? false : true;
    }

    let video = document.createElement("video");
    video.classList.add("video-bg__video");
    video.loop = videoloop;
    video.muted = videomuted;
    video.autoplay = videoAutoplay;
    video.controls = videocontrols;

    video.dataset.pauseout =
      videoContainers[i].getAttribute("data-pauseout") || false;

    let videoClass = videoContainers[i].getAttribute("data-class");
    if (videoClass) {
      video.classList.add(videoClass);
    }

    if (video.canPlayType("video/mp4").length > 0) {
      video.src = videosrc;
    } else {
      continue;
    }
    /*
    if (videoContainers[i].classList.contains("play-when-visible")) {
      video.pause();
      addObserverToVideo({ elements: [video] });
    }
      */

    videoContainers[i].appendChild(video);
  }
}

function addObserverToVideo(config) {
  const { root, threshold } = config;
  let { elements } = config;

  const options = {
    root: root ? root : null,
    threshold: threshold ? threshold : 0.2,
    rootMargin: "-10px",
  };

  if (!elements) {
    elements = [];
  }

  elements.forEach((element) => {
    element.pause();
  });

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        console.log("isIntersecting");
        console.log(entry.target);
        entry.target.play();
      } else {
        console.log("---- NO isIntersecting");
        console.log(entry.target);
        entry.target.pause();
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  elements.forEach((element) => {
    observer.observe(element);
  });
}
